import React from 'react';
import AdminSettings from '../teacher/AdminSettings';


const Admin = () => {
  return (
    <div>
    <AdminSettings />  
    </div>
  );
}

export default Admin;